import { render, staticRenderFns } from "./AmlBadge.vue?vue&type=template&id=6df022c6&scoped=true"
import script from "./AmlBadge.vue?vue&type=script&lang=js"
export * from "./AmlBadge.vue?vue&type=script&lang=js"
import style0 from "./AmlBadge.vue?vue&type=style&index=0&id=6df022c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df022c6",
  null
  
)

export default component.exports